import { callEndpoint } from '../backend';

export const addIncident = (values) =>
  callEndpoint(callEndpoint.endpoints.submitIncidentReport, values);

export const initialize = () => {};
